export default{
    section:'بخش',
    sectionTitle: 'عنوان',
    sectionStatus: 'وضعیت',
    sections:'بخش‌ها',
    editSection:'ویرایش بخش',
    addSection:'بخش جدید',
}